module.exports = __webpack_public_path__ + "media/images/borzo-276afe53c87d9a0996a87b724829f5db.png";